/**
 * Magazine page — lightbox gallery and trailer playback.
 *
 * The page itself is a plain vertical stack: the image, the copy, the Read more
 * expander and the Add to cart form all work with JavaScript disabled. This
 * file adds the gallery overlay and the trailer's play-to-fullscreen button.
 *
 * The gallery is whatever Liquid rendered — the slides and the thumbnails come
 * from one array in the section, so the two are always the same images in the
 * same order and nothing here needs its own copy of the list.
 */

(function () {
  "use strict";

  /* ------------------------------------------------------------------ */
  /* Lightbox                                                            */
  /* ------------------------------------------------------------------ */

  var lb = document.querySelector("[data-mag-lightbox]");

  if (lb) {
    var slides = Array.prototype.slice.call(lb.querySelectorAll("[data-mag-slide]"));
    var thumbs = Array.prototype.slice.call(lb.querySelectorAll("[data-mag-thumb]"));
    var openers = Array.prototype.slice.call(document.querySelectorAll("[data-mag-open]"));
    var closeBtn = lb.querySelector("[data-mag-close]");
    var prevBtn = lb.querySelector("[data-mag-prev]");
    var nextBtn = lb.querySelector("[data-mag-next]");

    var index = 0;
    var lastFocused = null;

    function show(i) {
      if (!slides.length) return;
      /* Wrap at both ends so the arrows never dead-end. */
      index = ((i % slides.length) + slides.length) % slides.length;

      slides.forEach(function (img, n) {
        img.hidden = n !== index;
      });
      thumbs.forEach(function (t, n) {
        t.setAttribute("aria-selected", n === index ? "true" : "false");
      });

      /* Keep the active thumbnail in view when the row scrolls. */
      var active = thumbs[index];
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ block: "nearest", inline: "nearest" });
      }
    }

    function open(i) {
      lastFocused = document.activeElement;
      show(i || 0);
      lb.hidden = false;
      document.body.classList.add("mag-lb-open");
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lb.hidden = true;
      document.body.classList.remove("mag-lb-open");
      /* Return focus to whatever opened it, rather than dumping the user at
         the top of the document. */
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    openers.forEach(function (el) {
      el.addEventListener("click", function () {
        open(parseInt(el.getAttribute("data-mag-open"), 10) || 0);
      });
    });

    thumbs.forEach(function (t, n) {
      t.addEventListener("click", function () {
        show(n);
      });
    });

    if (prevBtn) prevBtn.addEventListener("click", function () { show(index - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { show(index + 1); });
    if (closeBtn) closeBtn.addEventListener("click", close);

    /* Clicking the backdrop closes; clicking a control or the image does not. */
    lb.addEventListener("click", function (e) {
      if (e.target === lb) close();
    });

    document.addEventListener("keydown", function (e) {
      if (lb.hidden) return;
      if (e.key === "Escape") { e.preventDefault(); close(); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); show(index - 1); }
      else if (e.key === "ArrowRight") { e.preventDefault(); show(index + 1); }
      else if (e.key === "Tab") {
        /* Simple focus trap: keep tabbing inside the dialog while it is open. */
        var focusable = lb.querySelectorAll("button");
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* Swipe between images on touch. */
    var startX = null;
    lb.addEventListener("touchstart", function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    lb.addEventListener("touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(dx < 0 ? index + 1 : index - 1);
      startX = null;
    }, { passive: true });

    show(0);
  }

  /* ------------------------------------------------------------------ */
  /* Trailer                                                             */
  /* ------------------------------------------------------------------ */

  /*
   * The video carries no `controls` and no `muted`, so this overlay is the
   * only way to start it — and starting it means going straight to the native
   * fullscreen player with sound.
   *
   * Two constraints shape the code:
   *
   * 1. Fullscreen and unmuted playback are both gesture-gated. Everything
   *    therefore happens synchronously inside the click handler; awaiting the
   *    play() promise first would break the chain and iOS would refuse.
   * 2. `webkitEnterFullscreen` throws on iOS if the element has no metadata
   *    yet. When that happens the request is retried once, the moment metadata
   *    lands.
   */

  /* ---- Reveal on scroll ----
     Runs before the trailer wiring below, which returns early if the play
     button is absent — the fade should not depend on that. */
  var wrapper = document.querySelector(".mag__video");
  if (wrapper && "IntersectionObserver" in window) {
    /* Adding the class here, not in the markup, is what keeps the section
       visible when JavaScript is unavailable. */
    wrapper.classList.add("mag-reveal");

    new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add("is-visible");
          /* One-shot: it should not fade back out on the way past. */
          obs.unobserve(e.target);
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px" }
    ).observe(wrapper);
  }

  var button = document.querySelector("[data-mag-play]");
  if (!button) return;

  var frame = button.closest(".mag__video-frame");
  var video = frame ? frame.querySelector("video") : null;
  if (!frame || !video) return;

  function goFullscreen() {
    try {
      if (typeof video.webkitEnterFullscreen === "function") {
        video.webkitEnterFullscreen(); // iOS native player
        return true;
      }
      if (typeof video.requestFullscreen === "function") {
        video.requestFullscreen();
        return true;
      }
      if (typeof video.webkitRequestFullscreen === "function") {
        video.webkitRequestFullscreen(); // older desktop Safari
        return true;
      }
    } catch (e) {
      /* Swallowed deliberately: a refused fullscreen request must not stop
         playback, and the retry below covers the not-ready case. */
    }
    return false;
  }

  button.addEventListener("click", function (e) {
    e.preventDefault();

    /* Unmuted by design — the trailer is meant to be heard. */
    video.muted = false;

    var p = video.play();
    if (p && typeof p.catch === "function") {
      p.catch(function () {
        /* If a browser still refuses unmuted playback, fall back to muted so
           something plays rather than nothing. */
        video.muted = true;
        var retry = video.play();
        if (retry && typeof retry.catch === "function") retry.catch(function () {});
      });
    }

    if (!goFullscreen() && video.readyState < 1) {
      video.addEventListener("loadedmetadata", goFullscreen, { once: true });
    }
  });

  /* Leaving fullscreen stops playback rather than leaving audio running behind
     the page. Covers both the standard and the iOS-specific events. */
  function stopOnExit() {
    var stillFullscreen =
      document.fullscreenElement === video || document.webkitFullscreenElement === video;
    if (!stillFullscreen && !video.paused) video.pause();
  }
  document.addEventListener("fullscreenchange", stopOnExit);
  document.addEventListener("webkitfullscreenchange", stopOnExit);
  video.addEventListener("webkitendfullscreen", function () {
    if (!video.paused) video.pause();
  });
})();
